export default __webpack_public_path__ + "static/media/Waves.ad949c10.png";